export default __webpack_public_path__ + "static/media/answered.6cde2624.svg";